/// <reference types="vite-plugin-pwa/react" />
/**
 * PWA 서비스워커 보조 로직 (지침 §8) — UI 는 components/PwaUpdatePrompt.tsx.
 *
 * registerType "autoUpdate" (vite.config.ts): 새 SW 는 감지 즉시 활성화되지만,
 * 기본 동작(즉시 window.location.reload())은 임무 관제 중 화면을 예고 없이 날린다.
 * → onNeedReload 로 자동 리로드를 가로채 토스트로 사용자가 적용 시점을 결정.
 */

/** 장시간 관제 세션용 SW 갱신 확인 주기 — 관제 화면은 며칠씩 리로드 없이 떠 있으므로
 *  내비게이션 기반 업데이트 감지만으로는 부족 (vite-pwa 공식 periodic updates 패턴). */
export const SW_UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1_000; // 1시간

/**
 * 주기적으로 SW 스크립트 변경 여부를 확인해 registration.update() 트리거.
 * 오프라인·설치 진행 중이면 해당 주기는 건너뛴다 (다음 주기에 재시도).
 * @returns 정리 함수 (interval 해제)
 */
export function startPeriodicSwUpdateCheck(
  swUrl: string,
  registration: ServiceWorkerRegistration | undefined,
  intervalMs: number = SW_UPDATE_CHECK_INTERVAL_MS,
): () => void {
  if (!registration) return () => {};
  const timer = setInterval(async () => {
    if (registration.installing) return;
    if ("onLine" in navigator && !navigator.onLine) return;
    try {
      const resp = await fetch(swUrl, {
        cache: "no-store",
        headers: { "cache-control": "no-cache" },
      });
      if (resp.status === 200) await registration.update();
    } catch {
      /* 네트워크 일시 오류 — 다음 주기에 재시도 */
    }
  }, intervalMs);
  return () => clearInterval(timer);
}

/**
 * "새 버전 적용" — autoUpdate 모드에서는 새 SW 가 이미 활성화·제어 중이므로
 * 리로드만 하면 새 자산이 로드된다 (prompt 모드의 skipWaiting 메시지 불필요).
 */
export function applyPwaUpdate(): void {
  window.location.reload();
}
